import config from 'config';
import { RSAA } from 'redux-api-middleware';
export const submitDsg = (dsgDto, codexVersionId) => {

    return {
      [RSAA]: {
  
        endpoint: `${config.apiRoot}/cat/codex-version/${codexVersionId}/dynamic-switch-groups/`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dsgDto),
        types: [
          'DSG_SUBMIT_REQUEST',
          'DSG_SUBMIT_SUCCESS',
          'DSG_SUBMIT_FAILURE'
        ]
      }
    };
  };

export const resetDsgSubmitRequest = () => {
  return {
    type: "RESET_SUCCESS_MESSAGE_DSG_SUBMISSION"
  }
}